<template>
  <vx-card :collapse-action="true" title="Filter" @refresh="refreshResult">
    <div class="vx-row">
      <div class="w-full vx-col md:w-1/4 sm:w-1/2">
        <label class="text-sm opacity-75">
          STATUS
        </label>
        <v-select
          :options="fileStatuses"
          v-model="selectedStatus"
          class="w-1/10 select-small"
        />
      </div>
      <div class="w-full vx-col md:w-1/4 sm:w-1/2">
        <label class="text-sm opacity-75">
          CREATED AT
        </label>
        <vx-input-group class="mb-base">
          <datepicker
            :format="format"
            class="inputx"
            placeholder="From"
            v-model="createdAt"
          ></datepicker>
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button color="grey" type="border" @click="createdAt = ''"
                >X</vs-button
              >
            </div>
          </template>
        </vx-input-group>
      </div>
    </div>

    <div class="mt-2 vx-row"></div>
  </vx-card>
</template>

<script>
import vSelect from 'vue-select'
import { fileStatuses } from '@/constants/file-statuses'
import Datepicker from 'vuejs-datepicker'
import SearchSelect from '../../components/override/SearchSelect'
import * as moment from 'moment/moment'
// import axios from '@/axios.js'

export default {
  components: {
    vSelect,
    Datepicker,
    SearchSelect,
  },
  watch: {
    selectedStatus: function(val) {
      this.emitChange('fileStatus', '$eq', val ? val.key.toLowerCase() : '')
    },
    createdAt: function(val) {
      const firstSecondOfDay = moment(val)
      if (!firstSecondOfDay.isValid()) {
        this.emitChange('createdAt', '$gte', '')
        return
      }
      this.emitChange(
        'createdAt',
        '$gte',
        firstSecondOfDay.format('YYYY-MM-DDT00:00:00.000') + 'Z'
      )
    },
  },
  methods: {
    emitChange(attribute, searchType, value) {
      const recordIndex = this.search.findIndex(
        search => search[attribute] != undefined
      )
      if (recordIndex >= 0) {
        this.search.splice(recordIndex, 1)
      }
      if (value) {
        this.search.push({
          [attribute]: { [searchType]: value },
        })
      }
      this.refreshResult()
    },
    refreshResult() {
      this.timeout && window.clearTimeout(this.timeout)
      this.timeout = window.setTimeout(() => {
        this.$emit('change', {
          $and: this.search,
        })
        // this.$refs.filterCard.removeRefreshAnimation();
      }, 380)
    },
  },
  data() {
    return {
      format: 'yyyy-MM-dd',
      createdAt: null,
      selectedStatus: null,
      fileStatuses,
      search: [],
    }
  },
}
</script>
